import React, { Component } from 'react';
import { isEmpty, isEnergyDevice } from '../../../Common/Common';
import Switch from '../../../Part_Sample/Switch';
import ConfirmMessage from '../../../Part_Sample/ConfirmMessage';
import Editbox from '../../../Part_Sample/Editbox';
import Collapsible_Point_Selection from '../../util/Collapsible_Point_Selection';
import delete_icon from '../../../../Images/Daikin_Images/image/Delete.png';
import up_icon from '../../../../Images/Daikin_Images/image/up.png'; //Tommy - 09/04/2021
import down_icon from '../../../../Images/Daikin_Images/image/down.png'; //Tommy - 09/04/2021

export default class Energy_Categories extends Component {
	constructor(props) {
		super(props);

		this.state = {
			// show confirm prompt for delete
			is_show_confirm: false,
			// For display
			is_show_energy_generator_points: false,
			is_show_display_energy_categories: false,
		}
	}

	// set is_show_energy_categories in the report settings 
	handleToggleShowCategories = () => {
		let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
		report_settings.categories.is_show_energy_categories = !report_settings.categories.is_show_energy_categories;
		this.props.handleModifyCategories(report_settings);

		this.setState({ is_show_display_energy_categories: report_settings.categories.is_show_energy_categories });
	}

	// set is_energy_generator_enabled in the report settings config and close energy generator points display if disabled
	handleToggleEnergyGenerator = () => {
		if (this.props.report_settings.categories.is_show_energy_categories) {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			report_settings.categories.is_energy_generator_enabled = !report_settings.categories.is_energy_generator_enabled;
			this.props.handleModifyCategories(report_settings);

			this.setState({ is_show_energy_generator_points: report_settings.categories.is_energy_generator_enabled });
		}
	}

	// set the is_enabled for a specific energy category
	handleToggleEnergyCategory = (id) => {
		if (this.props.report_settings.categories.is_show_energy_categories) {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			let energy = report_settings.categories.energy;
			let is_enabled = energy[id].is_enabled;
			if (is_enabled) {
				energy[id].is_enabled = false;
				energy[id].is_show_points = false;
			} else {
				energy[id].is_enabled = true;
				energy[id].is_show_points = true;
			}

			report_settings.categories.energy = energy;
			this.props.handleModifyCategories(report_settings);
		}
	}

	// Add a new user defined energy category
	addCategory = () => {
		if (this.props.report_settings.categories.is_show_energy_categories) {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			let energy = report_settings.categories.energy;
			let energy_category_ids = Object.keys(energy);
			let new_id = 101;
			if (energy_category_ids.length > 0) {
				// let the new id be the biggest id in existing energy ids plus 1 
				new_id = Math.max(...energy_category_ids) + 1;
			}

			energy[new_id] = {};
			energy[new_id].is_enabled = true;
			energy[new_id].name = this.props.receiver.getString('new_category');
			energy[new_id].points = [];
			energy[new_id].is_show_points = true;

			report_settings.categories.energy = energy;
			this.props.handleModifyCategories(report_settings);
		}
	}

	// Change a specific energy category name
	handleChangeEnergyCategoryName = (val, id) => {
		if (this.props.report_settings.categories.is_show_energy_categories) {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			let energy = report_settings.categories.energy;
			energy[id].name = val;

			report_settings.categories.energy = energy;
			this.props.handleModifyCategories(report_settings);
		}
	}

	// Add or Remove a point from energy generator category
	handleEnergyGeneratorPoints = (point_id) => {
		if (!(Object.keys(window.app.state.point_list)).includes(point_id)) {
			// If the point id does not exist in current point_list
			this.setState({ is_show_confirm: true });
			this.id_to_be_deleted = { type: 'energy_generator', point_id: point_id };
		} else {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			let energy_generator = report_settings.categories.energy_generator;
			if (energy_generator.points.includes(point_id)) energy_generator.points.splice(energy_generator.points.indexOf(point_id), 1);
			else energy_generator.points.push(point_id);

			report_settings.categories.energy_generator = energy_generator;
			this.props.handleModifyCategories(report_settings);
		}
	}

	// Add or Remove a point from a specific energy category
	handleEnergyCategoryPoints = (category_id, point_id) => {
		if (!(Object.keys(window.app.state.point_list)).includes(point_id)) {
			// If the point id does not exist in current point_list
			this.setState({ is_show_confirm: true });
			this.id_to_be_deleted = { type: 'energy', category_id: category_id, point_id: point_id };
		} else {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			let energy = report_settings.categories.energy;
			if (energy[category_id].points.includes(point_id)) energy[category_id].points.splice(energy[category_id].points.indexOf(point_id), 1);
			else energy[category_id].points.push(point_id);

			report_settings.categories.energy = energy;
			this.props.handleModifyCategories(report_settings);
		}
	}

	// Delete a specific user defined energy category
	handleDeleteCategory = (category_id) => {
		// Delete the category created by user
		if (this.props.report_settings.categories.is_show_energy_categories) {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			let energy = this.props.report_settings.categories.energy;
			delete energy[category_id];

			report_settings.categories.energy = energy;
			this.props.handleModifyCategories(report_settings);
		}
	}

	// Confirm delete a point that doesnt exist
	onConfirm = (is_pressed_ok) => {
		if (is_pressed_ok) {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			if (this.id_to_be_deleted.type == 'energy_generator') {
				let energy_generator = report_settings.categories.energy_generator;
				let point_id = this.id_to_be_deleted.point_id;
				if (energy_generator.points.includes(point_id)) energy_generator.points.splice(energy_generator.points.indexOf(point_id), 1);
				report_settings.categories.energy_generator = energy_generator;
			} else if (this.id_to_be_deleted.type == 'energy') {
				let energy = report_settings.categories.energy;
				let category_id = this.id_to_be_deleted.category_id;
				let point_id = this.id_to_be_deleted.point_id;
				if (energy[category_id].points.includes(point_id)) energy[category_id].points.splice(energy[category_id].points.indexOf(point_id), 1);
				report_settings.categories.energy = energy;
			}
			this.props.handleModifyCategories(report_settings);
		}
		this.id_to_be_deleted = null;
		this.setState({ is_show_confirm: false });
	}

	/*
	 * For Display
	 */

	inputOnFocus = () => {
		this.is_input_onfocus = true;
	}

	inputOnBlur = () => {
		this.is_input_onfocus = false;
	}

	// Toggle show energy categories display 
	handleToggleShowEnergyCategories = () => {
		this.setState({ is_show_display_energy_categories: !this.state.is_show_display_energy_categories });
	}

	// Toggle energy category points display
	handleShowEnergyPoints = (event, category_id) => {
		if (event.target.id.substring(0, 13) == 'category_main' || event.target.id.substring(0, 13) == 'category_name') {
			let report_settings = JSON.parse(JSON.stringify(this.props.report_settings));
			let energy = this.props.report_settings.categories.energy;
			energy[category_id].is_show_points = !energy[category_id].is_show_points;

			report_settings.categories.energy = energy;
			this.props.handleModifyCategories(report_settings);
		}
	}

	// Toggle energy generator points display 
	handleShowEnergyGeneratorPoints = () => {
		this.setState({ is_show_energy_generator_points: !this.state.is_show_energy_generator_points });
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let card_style = {
			background: 'white',
			padding: '0px 10px',
			width: this.props.width - 60,
			marginLeft: 'auto',
			marginRight: 'auto',
			marginTop: 10,
			textAlign: 'left',
		}

		let card_shadow_style = {
			background: 'white',
			borderRadius: 20,
			padding: 10,
			width: this.props.width - 90,
			marginLeft: 'auto',
			marginRight: 'auto',
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		let collapsible_energy_categories = {
			height: this.is_input_onfocus ? this.props.height - 380 : 'unset',
			maxHeight: this.state.is_show_display_energy_categories ? this.props.height - 380 : 0,
			transition: 'max-height 0.6s ease-out',
			overflow: 'auto',
			opacity: this.props.report_settings.categories.is_show_energy_categories ? 1 : 0.2,
		}

		let selected_points = [];

		for (let category_id in this.props.report_settings.categories.energy) {
			selected_points = selected_points.concat(this.props.report_settings.categories.energy[category_id].points);
		}
		selected_points = selected_points.concat(this.props.report_settings.categories.energy_generator.points);

		let points_selection = {};
		// Get the selection of points
		for (let point_id in window.app.state.point_list) {
			let point_info = window.app.state.point_list[point_id];
			if (isEnergyDevice(point_info)) {
				points_selection[point_id] = point_info;
			}
		}

		return (
			<div style={style}>
				<ConfirmMessage
					is_show={this.state.is_show_confirm}
					message={this.props.receiver.getString('del_conf_no_mp')}
					width={this.props.width}
					height={this.props.height}
					receiver={this.props.receiver}
					handleClick={this.onConfirm}
				/>
				<div style={{ overflow: 'auto', width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto', marginTop: 10, boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)', borderRadius: 20 }}>
					<div style={{ textAlign: 'left', marginLeft: 10 }}>
						<span className="header">{this.props.receiver.getString('energy')}</span>
					</div>
					<div style={{ textAlign: 'left' }}>
						<span className='footnote' style={{ fontSize: 12 }}>{this.props.receiver.getString('energy_setting_explanation')}</span>
					</div>
					<div style={card_style}>
						<div style={{ display: 'inline-block', width: this.props.width - 120, textAlign: 'left', paddingTop: 5 }}>
							<span style={{ fontSize: 20 }}>{this.props.receiver.getString('show_categories')}</span>
						</div>
						<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.props.report_settings.categories.is_show_energy_categories} handleToggleSwitch={this.handleToggleShowCategories} />
					</div>
					<div style={{ opacity: this.props.report_settings.categories.is_show_energy_categories ? 1 : 0.4 }}>
						<div style={card_style}>
							<div style={{ cursor: 'pointer', display: 'inline-block', width: this.props.width - 120, textAlign: 'left', paddingTop: 5 }} onClick={this.handleToggleShowEnergyCategories}>
								<span style={{ fontSize: 20 }}>{this.props.receiver.getString('energy_consumption')}</span>
							</div>
							<img src={this.state.is_show_display_energy_categories ? up_icon : down_icon} style={{ width: 20, height: 20 }} />
							<div style={collapsible_energy_categories}>
								{Object.keys(this.props.report_settings.categories.energy).map((category_id) => {
									let category = this.props.report_settings.categories.energy[category_id];
									return (
										<div style={card_shadow_style} >
											<div id={'category_main_' + category_id} style={{ cursor: 'pointer', }} onClick={(event) => this.handleShowEnergyPoints(event, category_id)}>
												<img src={delete_icon} style={{ cursor: 'pointer', width: 25, marginRight: 10 }} onClick={() => this.handleDeleteCategory(category_id)} />
												<div id={'category_name_' + category_id} style={{ display: 'inline-block', width: this.props.width - 175 }} >
													<Editbox
														id={'category_' + category_id}
														style={{ width: '80%' }}
														inputStyle={{ marginTop: 0, fontSize: 22 }}
														inputType={'text'}
														onChange={(event) => this.handleChangeEnergyCategoryName(event.target.value, category_id)}
														onFocus={this.inputOnFocus}
														onBlur={this.inputOnBlur}
														value={category.name}
													/>
												</div>
												<Switch id={'category_switch_' + category_id} style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={category.is_enabled} handleToggleSwitch={() => this.handleToggleEnergyCategory(category_id)} />
											</div>
											<Collapsible_Point_Selection
												is_show={category.is_show_points}
												is_disabled={!this.props.report_settings.categories.is_show_energy_categories && category.is_enabled}
												max_height={this.props.height - 480}
												width={this.props.width - 20}
												points_selection={points_selection}
												handleTogglePoints={(point_id) => this.handleEnergyCategoryPoints(category_id, point_id)}
												selected_points={category.points}
												disabled_points={selected_points.filter((s_point_id) => !category.points.includes(s_point_id))}
											/>
										</div>
									)
								})}
								<div style={{ cursor: 'pointer', marginTop: 20, marginBottom: 20 }} onClick={this.addCategory}>
									<span style={{ color: window.app.state.lightBlue }}>{this.props.receiver.getString('tap_here_to_add_category')}</span>
								</div>
							</div>
						</div>
						<div style={{ ...card_style, marginBottom: 10 }}>
							<div style={{ cursor: 'pointer', display: 'inline-block', width: this.props.width - 120, textAlign: 'left', paddingTop: 5 }} onClick={this.handleShowEnergyGeneratorPoints}>
								<span style={{ fontSize: 20 }}>{this.props.receiver.getString('energy_generator')}</span>
							</div>
							<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.props.report_settings.categories.is_energy_generator_enabled} handleToggleSwitch={this.handleToggleEnergyGenerator} />
							<Collapsible_Point_Selection
								is_show={this.state.is_show_energy_generator_points}
								is_disabled={!this.props.report_settings.categories.is_energy_generator_enabled}
								max_height={this.props.height - 480}
								width={this.props.width}
								points_selection={points_selection}
								handleTogglePoints={this.handleEnergyGeneratorPoints}
								selected_points={this.props.report_settings.categories.energy_generator.points}
								disabled_points={selected_points.filter((s_point_id) => !this.props.report_settings.categories.energy_generator.points.includes(s_point_id))}
							/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}